import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { RepositoryEntries } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { newTextField } from '../../../../ui/widgets/text-input/text-field';
import { DisplayImg, DisplayText } from '../../common/editor';
import { FileContent, ImgDropzone } from '../dropzone/dropzone';
import { RepositoryFilePicker } from '../repository-file-picker/repository-file-picker';

const styles = require('../../common/editor.css');

interface ImageFileManagerProps {
  debug?: boolean;
  defaultUrl?: string;
  repositoryEntries?: RepositoryEntries;
  hideFileSelector?: boolean;
  hidePath?: boolean;
  title: string;
  isMandatory?: boolean;
  onChange(file: SelectedFileSpec): void;
}

/// remoteFile is currently unused
type ImgSelectionType = 'default' | 'repositoryFile' | 'upload' | 'remoteFile';
export interface SelectedFileSpec {
  kind: ImgSelectionType;
  reposName?: string;
  reposPath?: string;
  filePath: string;
  uri: string;
  /// Use Base64 data; send to server; decode on server
  /// (Alternative: Use content data ArrayBuffer (ADL type Bytes))
  data?: string;
  contentType?: string;
}

export class ImageFileManager extends React.Component<ImageFileManagerProps> {
  @observable fieldState = {
    url: newTextField(),
    path: '',
    source: 'default'
  };
  @observable data: string = ''; // | ArrayBuffer = new ArrayBuffer(0);

  constructor(props: ImageFileManagerProps) {
    super(props);
    if (props.defaultUrl) {
      this.onChange(props.defaultUrl, props.defaultUrl, 'default');
    }
  }

  @observable uploadData = {
    files: Array<File>(),
    contents: Array<FileContent>()
  };

  ImageObserver = observer(() => {
    return (
      <React.Fragment>
        {DisplayImg({
          field: this.fieldState.url.value(),
          title: `Current ${this.props.title}`,
          xsSpan: 4,
          debug: this.props.debug,
          isMandatory: this.props.isMandatory
        })}
        {!this.props.hidePath && DisplayText({
          field: this.fieldState.path,
          title: 'Path',
          xsSpan: 4
        })}
      </React.Fragment>
    );
  });

  @action
  getFiles = (files: Array<File>) => {
    this.uploadData.files = files;
  };

  @action
  getContent = (contents: Array<FileContent>) => {
    this.uploadData.contents = contents;
    // Only one allowed
    const content = contents.slice(-1)[0];
    if (content.dataUri && content.content) {
      this.onChange(content.dataUri, content.name, 'upload', content.content as string, content.contentType);
    } else {
      console.log('[IMG] Uploaded file with no dataUri??');
    }
  };

  @action
  onChange = (
    newUri: string,
    newPath: string,
    newSource: 'default' | 'repositoryFile' | 'upload',
    newData?: string,
    contentType?: string
  ) => {
    const { repositoryEntries } = this.props;
    this.fieldState.url.onChange(newUri);
    if (newSource === 'upload' && newData) {
      this.data = newData;
    }
    this.fieldState = {
      ...this.fieldState,
      path: newPath,
      source: newSource
    };
    this.props.onChange({
      kind: newSource,
      reposName: repositoryEntries ? repositoryEntries.repositoryName : undefined,
      reposPath: repositoryEntries ? repositoryEntries.path : undefined,
      filePath: newPath,
      uri: newUri,
      data: this.data,
      contentType
    });
  };

  @action
  onFileSelectChange = (newFile: string): void => {
    const { repositoryEntries } = this.props;
    if (repositoryEntries) {
      // Should be for this to fire...
      const entry = repositoryEntries.entries.find(e => e.value.path === newFile);
      if (entry) {
        // Should be for this to be loaded...
        if (entry.kind === 'file') {
          this.onChange(entry.value.publicUrl, entry.value.path, 'repositoryFile');
        }
      }
    }
  };

  @computed
  get inputIsValid(): boolean {
    return this.fieldState.url.getValid() !== undefined;
  }

  FileSelector = () => {
    /// TODO Before we sort out client's own repos...
    const { hideFileSelector, repositoryEntries } = this.props;
    if (hideFileSelector === true) {
      return null;
    } else {
      return (
        <div className={styles.row}>
          {repositoryEntries && (
            <RepositoryFilePicker
              data={repositoryEntries}
              currentFile={this.fieldState.path}
              onChange={this.onFileSelectChange}
            />
          )}
        </div>
      );
    }
  };

  EditImage = () => {
    return (
      <React.Fragment>
        <div className={styles.page}>
          <div className={styles.body}>
            <div className={styles.row}>
              <this.ImageObserver />
            </div>
            <div className={styles.row}>
              <ImgDropzone files={this.getFiles} contents={this.getContent} multiple={false} />
            </div>
            <this.FileSelector />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return <this.EditImage />;
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/image-file-manager/image-file-manager.tsx